import React, { useEffect } from 'react'
import './Pravachan.css'
import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
import Latest_Card from '../../common/common_components/latest_card/Latest_Card'
import { useDispatch, useSelector } from 'react-redux';
import { AllPravachan, OurCoreVision } from '../../../features/admin/common/Slice';
import parse from "html-react-parser";



const Pravachan = () => {

    const dispatch = useDispatch();
    const all_pravachan = useSelector((state) => state.common.all_pravachan);


    useEffect(() => {
        dispatch(AllPravachan());
    }, [dispatch])
    return (
        <>
            <section className='Pravachan_section'>
                <div className='container'>
                    <Common_Title_2 subText="Pravachan" />

                    <div className='allpravachans'>
                        <div className="row">
                            {all_pravachan?.slice(0, 4)?.map(
                                ((pravachan, index) => (
                                    <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>

                                        <Latest_Card
                                            mediaContent={
                                                <iframe
                                                    className="media_content"
                                                    src={pravachan?.Pravachan?.url}
                                                    title={pravachan?.name}
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    referrerPolicy="strict-origin-when-cross-origin"
                                                    allowFullScreen
                                                ></iframe>
                                            }
                                            name={pravachan?.name}
                                            description={pravachan?.description}
                                        />
                                        {/* <Latest_Card
                                            mediaContent={parse(pravachan?.Pravachan?.url || " ")}
                                            name={pravachan?.name}
                                            description={pravachan?.description}
                                            link={pravachan?.name}
                                        /> */}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    {/* <div className='allpravachans'>
                        <div className="row">
                            {Array?.from({ length: 4 })?.map(
                                ((_, index) => (
                                    <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                                        <Latest_Card
                                            mediaContent={
                                                <iframe
                                                    className="media_content"
                                                    src="https://www.youtube.com/embed/1EZeY3IB1wk?list=PLKXRcYa-eMHpk454gGzeYr9FEAd4I1Q8z"
                                                    title="Dhyan Yogi Shri Narayan Swami #shorts"
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    referrerPolicy="strict-origin-when-cross-origin"
                                                    allowFullScreen
                                                ></iframe>
                                            }
                                        />
                                    </div>
                                ))
                            )}
                        </div>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default Pravachan